import React, { Fragment } from 'react';
import { ButtonTypes } from '../Reusable/Buttons/Types';

const CustomNavigationIcon = ({ width, height, roundSvgBackground, arrowSvgColor }: ButtonTypes) => {
	return (
		<Fragment>
			<svg width={width} height={height} viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M24.3159 48.0002C37.5707 48.0002 48.3159 37.255 48.3159 24.0001C48.3159 10.7452 37.5707 0 24.3159 0C11.0611 0 0.315918 10.7452 0.315918 24.0001C0.315918 37.255 11.0611 48.0002 24.3159 48.0002Z"
					fill={roundSvgBackground}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20.8212 35.9609C19.8343 35.9609 18.9082 35.5756 18.212 34.8794C16.7721 33.4395 16.7721 31.0977 18.212 29.6589L23.8689 24.001L18.212 18.344C16.7721 16.9042 16.7721 14.5633 18.212 13.1235C18.9082 12.4272 19.8352 12.0429 20.8212 12.0429C21.8072 12.0429 22.7333 12.4272 23.4305 13.1235L34.0734 23.7663C34.2028 23.8957 34.2028 24.1052 34.0734 24.2356L23.4305 34.8784C22.7333 35.5746 21.8062 35.9599 20.8212 35.9599V35.9609Z"
					fill={arrowSvgColor}
				/>
			</svg>
		</Fragment>
	);
};

export default CustomNavigationIcon;
